import { LoadingOutlined } from '@ant-design/icons';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

// DS
import {
  Col,
  Form,
  VertInput,
  VertRadio,
  Row,
  VertTypography,
  VertLoading,
} from '@vertem-core/vertice-ds';

// STYLES
import 'Assets/styles/default/components/Forms/FormsStyles.less';
import 'Assets/styles/default/components/Profile/Profile.less';
import MaskedInput from 'pages/newSolicitation/components/InputMask';
import ynToBool from "Utils/ynToBool";
import isFakeEmail from "Utils/isFakeEmail"

// FORMS PERSONAL DATA COMPONENT
const FormsPersonalData = ({ ...props }) => {
  const [useForm] = Form.useForm();
  const { onChange, form, isValid, clientHasIEValidation, stateInscriptionIsLoading, validateIeEmitter } = props;


  const verifyEmail = props?.form?.email?.value;
  const fakeEmail = (ynToBool(process.env.REACT_APP_HIDE_FAKE_EMAIL) && isFakeEmail(verifyEmail)) ?
    { display: 'none' } : {};



  const handleChange = (name, value) => {
    const fieldsErros = useForm.getFieldsError();
    const hasValid = fieldsErros.find((a) => a.errors.length > 0)
      ? false
      : true;
    isValid({ personalData: hasValid });
    onChange(name, value);
  };

  useEffect(() => {
    if (useForm) {
      const fieldsErros = useForm.getFieldsError();
      const hasValid = fieldsErros.find((a) => a.errors.length > 0)
        ? false
        : true;
      isValid({ personalData: hasValid });
    }
  }, []);

  useEffect(() => {
    if (form.stateInscription.value) {
      useForm.setFieldValue('stateInscription', form.stateInscription.value);
    }
  }, [form.stateInscription]);

  return (
    <Col className="forms-method-payment-wrapper col-12 container-form-personal-data">
      <div>
        <Row className="checkout-summary-title">
          <VertTypography.Title
            level={3}
            className="margin-bottom-small"
          >
            Dados pessoais
          </VertTypography.Title>
        </Row>
        <Form
          name="FormsPersonalData"
          form={useForm}
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          initialValues={{ remember: true }}
          autoComplete="off"
          layout="vertical"
          className='form-personal-data'
        >
          <div className="formItem">
            <Form.Item
              name="name"
              initialValue={form.name.value}
              validateTrigger={['onBlur']}
              rules={[
                { required: true, message: 'Nome precisa ser preenchido.' },
              ]}
            >
              <VertInput
                template="marketplace"
                label="Nome Completo"
                disabled={form.name.disabled}
                onChange={({ target }) => handleChange('name', target.value)}
              />
            </Form.Item>
          </div>
          <Row gutter={0}>

            <div className="formItem">
              <Form.Item
                initialValue={form.documentNumber.value}
                name="documentNumber"
                validateTrigger={['onBlur']}
                rules={[
                  { required: true, message: 'CPF precisa ser preenchido.' },
                ]}
              >
                <MaskedInput
                  mask={'999.999.999-99'}
                  label="CPF"
                  placeholder=""
                  prefix={<LoadingOutlined />}
                  template="marketplace"
                  disabled={form.documentNumber.disabled}
                  onChange={(e) => {
                    const value = e.replace(/[^0-9]/g, '');
                    if (value.length === 11) {
                      handleChange('documentNumber', value);
                    }
                  }}
                />
              </Form.Item>


              <Form.Item
                initialValue={form.birthDate.value}
                name="birthDate"
                validateTrigger={['onBlur']}
                rules={[
                  {
                    required: true,
                    message: 'Data De Nascimento precisa ser preenchido.',
                  },
                ]}
              >

                <MaskedInput
                  mask={'99/99/9999'}
                  label="Data de Nascimento"
                  placeholder=""
                  prefix={<LoadingOutlined />}
                  template="marketplace"
                  disabled={form.birthDate.disabled}
                  onChange={(e) => {
                    const value = e.replace(/[^0-9]/g, '');
                    if (value.length === 8) {
                      handleChange('birthDate', value);
                    }
                  }}
                />
              </Form.Item>


              {
                clientHasIEValidation && (
                  <Form.Item
                    initialValue={form.stateInscription.value}
                    name="stateInscription"
                    validateTrigger={['onBlur', 'onChange']}
                    rules={[
                      {
                        required: true,
                        message: 'Inscrição estadual precisa ser preenchido.',
                      },
                    ]}
                  >

                    <VertInput
                      template="marketplace"
                      label="Inscrição estadual"
                      disabled={stateInscriptionIsLoading || form.stateInscription.disabled}
                      onBlur={() =>
                        validateIeEmitter(useForm.getFieldValue('stateInscription'))
                      }
                      onChange={({ target }) =>
                        handleChange('stateInscription', target.value)
                      }
                      suffix={stateInscriptionIsLoading && <VertLoading size='small' type='spin' className='color-detached' />}
                    />

                  </Form.Item>
                )
              }
            </div>
          </Row>

          <div className="formItem">
            <Form.Item
              name="phone"
              validateTrigger={['onBlur']}
              rules={[
                { required: true, message: 'Celular precisa ser preenchido.' },
              ]}
              initialValue={form.phone.value}
            >
              <MaskedInput
                mask={'(99) 99999-9999'}
                label="Celular"
                placeholder=""
                prefix={<LoadingOutlined />}
                template="marketplace"
                disabled={ynToBool(process.env.REACT_APP_BLOCK_EDIT_PHONE || form.phone.disabled  )}
                onChange={(e) => {
                  const value = e.replace(/[^0-9]/g, '');
                  if (value.length === 11) {
                    handleChange('phone', value);
                  }
                }}
              />
            </Form.Item>
            <Form.Item
              name="email"
              validateTrigger={['onBlur']}
              rules={[
                {
                  required: true,
                  message: 'Email precisa ser preenchido.',
                },
                { type: 'email', message: 'Email inválido' },
              ]}
              initialValue={form.email.value}
              style={fakeEmail}
            >
              <VertInput
                template="marketplace"
                label="Email"
                disabled={form.email.disabled}
                onChange={({ target }) => handleChange('email', target.value)}
              />
            </Form.Item>
          </div>
        </Form>
      </div>
    </Col>
  );
};

const type = PropTypes.shape({
  value: PropTypes.any,
  disabled: PropTypes.bool,
});

FormsPersonalData.propTypes = {
  form: PropTypes.shape({
    name: type,
    documentNumber: type,
    birthDate: type,
    phone: type,
    email: type
  }),
  onChange: PropTypes.func,
  isValid: PropTypes.func,
};


export default FormsPersonalData;
